import { Get as Get$1 } from './individual-ofac-check.dto.mjs';

var Get;
(function (Get) {
    Get.responseSchema = Get$1.responseSchema;
})(Get || (Get = {}));

export { Get };
